(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"]) return;
  try {
    
  (function () {
    'use strict';

    var MIN_COPIES = 2; // never scroll a single pass of the item list

    function fill(root) {
      var track = root.querySelector('[data-marquee-track]');
      var groups = root.querySelectorAll('[data-marquee-group]');
      if (!track || groups.length < 2) return;

      var source = groups[0];
      var mirror = groups[1];

      // Reset to the authored items before re-measuring (resize / editor reload).
      if (source.dataset.marqueeSeed) {
        source.innerHTML = source.dataset.marqueeSeed;
      } else {
        source.dataset.marqueeSeed = source.innerHTML;
      }
      mirror.innerHTML = '';

      var seedWidth = source.scrollWidth;
      if (!seedWidth) return;

      var copiesNeeded = Math.max(MIN_COPIES, Math.ceil(root.clientWidth / seedWidth) + 1) - 1;
      var seed = source.innerHTML;
      if (copiesNeeded > 0) {
        // Padding copies are decorative: hide from a11y tree, keep out of tab order.
        var pad = document.createElement('span');
        pad.style.display = 'contents';
        pad.setAttribute('aria-hidden', 'true');
        var copies = '';
        for (var i = 0; i < copiesNeeded; i++) copies += seed;
        pad.innerHTML = copies;
        pad.querySelectorAll('a').forEach(function (a) {
          a.setAttribute('tabindex', '-1');
        });
        source.appendChild(pad);
      }
      mirror.innerHTML = source.innerHTML;
      mirror.querySelectorAll('a').forEach(function (a) {
        a.setAttribute('tabindex', '-1');
      });

      var speed = parseFloat(root.style.getPropertyValue('--marquee-speed')) || 60;
      var duration = source.scrollWidth / speed;
      root.style.setProperty('--marquee-duration', duration.toFixed(2) + 's');
    }

    function initAll() {
      document.querySelectorAll('[data-marquee]').forEach(fill);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initAll);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initAll, 200);
    });

    // Theme editor re-renders the section without a page load.
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-marquee]');
      if (root) fill(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    var cartChangeUrl = root.getAttribute('data-cart-change-url');
    if (!cartChangeUrl) return;

    var LABEL_REMOVE = root.getAttribute('data-label-remove') || 'Remove';
    var LABEL_DEC = root.getAttribute('data-label-decrease') || 'Decrease quantity';

    var debounceMs = 420;
    var inputTimers = {};
    var feedbackTimers = {};

    function currencyCode(cart) {
      var c = cart && cart.currency;
      if (!c) return 'USD';
      if (typeof c === 'string') return c;
      if (c.iso_code) return c.iso_code;
      return 'USD';
    }

    function formatLineMoney(cents, cart) {
      var code = currencyCode(cart);
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function patchHeaderCart(cart) {
      var link = document.querySelector('[data-header-cart-link]');
      if (!link) return;
      var count = typeof cart.item_count === 'number' ? cart.item_count : 0;
      var sup = link.querySelector('[data-header-cart-count]');
      if (count > 0) {
        if (!sup) {
          sup = document.createElement('sup');
          sup.setAttribute('data-header-cart-count', '');
          sup.className = 'header-cart-count';
          link.appendChild(sup);
        }
        sup.textContent = String(count);
      } else if (sup) {
        sup.remove();
      }
    }

    function syncLineRow(row, item, cart) {
      var input = row.querySelector('[data-cart-qty-input]');
      if (input) {
        input.value = String(item.quantity);
        input.setAttribute('data-original-qty', String(item.quantity));
      }
      var priceEl = row.querySelector('[data-cart-line-price]');
      if (priceEl) {
        priceEl.textContent = formatLineMoney(item.final_line_price, cart);
      }
      var compareEl = row.querySelector('[data-cart-line-compare]');
      var wrapEl = row.querySelector('[data-line-unit-compare]');
      if (compareEl && wrapEl) {
        var unitCompare = parseInt(wrapEl.getAttribute('data-line-unit-compare'), 10) || 0;
        compareEl.textContent = formatLineMoney(unitCompare * item.quantity, cart);
      }
      var dec = row.querySelector('[data-cart-qty-dec]');
      if (dec) {
        dec.setAttribute('aria-label', item.quantity <= 1 ? LABEL_REMOVE : LABEL_DEC);
      }
      clearLineFeedback(row);
    }

    function setLineFeedback(row, message) {
      if (!row) return;
      var key = getLineKey(row);
      var feedback = row.querySelector('[data-cart-line-feedback]');
      if (!feedback) return;
      if (key && feedbackTimers[key]) { clearTimeout(feedbackTimers[key]); delete feedbackTimers[key]; }
      if (!message) {
        feedback.textContent = '';
        feedback.classList.add('hidden');
        return;
      }
      feedback.textContent = message;
      feedback.classList.remove('hidden');
      if (key) {
        feedbackTimers[key] = setTimeout(function () {
          feedback.textContent = '';
          feedback.classList.add('hidden');
          delete feedbackTimers[key];
        }, 5000);
      }
    }

    function clearLineFeedback(row) {
      setLineFeedback(row, '');
    }

    function patchCartDom(cart) {
      patchHeaderCart(cart);

      var keysSeen = {};
      cart.items.forEach(function (item) {
        keysSeen[item.key] = true;
      });

      document.querySelectorAll('[data-cart-line]').forEach(function (row) {
        var key = row.getAttribute('data-line-key');
        var item = cart.items.find(function (i) {
          return i.key === key;
        });
        if (!item) {
          row.remove();
          return;
        }
        syncLineRow(row, item, cart);
      });

      var emptyEl = root.querySelector('[data-cart-empty]');
      var mainEl = root.querySelector('[data-cart-main]');
      if (!cart.items || cart.items.length === 0) {
        if (emptyEl) emptyEl.classList.remove('hidden');
        if (mainEl) mainEl.classList.add('hidden');
      } else {
        if (emptyEl) emptyEl.classList.add('hidden');
        if (mainEl) mainEl.classList.remove('hidden');
      }
    }

    var mutex = Promise.resolve();

    function changeLine(lineKey, quantity) {
      var run = function () {
        root.classList.add('cart-page--updating');
        return fetch(cartChangeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: lineKey, quantity: quantity }),
        })
          .then(function (res) {
            if (res.ok) return res.json();
            return res
              .json()
              .catch(function () {
                return {};
              })
              .then(function (body) {
                var msg = body && (body.description || body.message);
                throw new Error(msg || 'Unable to update cart quantity.');
              });
          })
          .then(function (cart) {
            patchCartDom(cart);
            return cart;
          })
          .finally(function () {
            root.classList.remove('cart-page--updating');
          });
      };

      var p = mutex.then(run, run);
      mutex = p.catch(function () {});
      return p;
    }

    function getLineRow(el) {
      return el && el.closest ? el.closest('[data-cart-line]') : null;
    }

    function getLineKey(row) {
      return row ? row.getAttribute('data-line-key') : null;
    }

    function commitInput(input) {
      var row = getLineRow(input);
      var lineKey = getLineKey(row);
      if (!lineKey) return;
      clearLineFeedback(row);

      var qty = parseInt(input.value, 10);
      var original = parseInt(input.getAttribute('data-original-qty'), 10);
      if (isNaN(qty) || qty < 0) {
        input.value = String(original);
        return;
      }
      if (qty === original) return;

      changeLine(lineKey, qty).catch(function (err) {
        input.value = String(original);
        setLineFeedback(row, err && err.message ? err.message : 'Unable to update cart quantity.');
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var dec = t.closest('[data-cart-qty-dec]');
      var inc = t.closest('[data-cart-qty-inc]');
      var rm = t.closest('[data-cart-line-remove]');

      if (!dec && !inc && !rm) return;

      e.preventDefault();
      var row = getLineRow(dec || inc || rm);
      var lineKey = getLineKey(row);
      if (!lineKey || !row) return;

      var input = row.querySelector('[data-cart-qty-input]');
      var q = input ? parseInt(input.value, 10) || 0 : 0;

      if (rm) {
        clearLineFeedback(row);
        changeLine(lineKey, 0).catch(function (err) {
          setLineFeedback(row, err && err.message ? err.message : 'Unable to update cart quantity.');
        });
        return;
      }
      if (inc) {
        clearLineFeedback(row);
        var incMax = parseInt(row.getAttribute('data-line-max'), 10);
        if (!isNaN(incMax) && q >= incMax) {
          setLineFeedback(row, 'Only ' + incMax + ' available');
          return;
        }
        changeLine(lineKey, q + 1).catch(function (err) {
          setLineFeedback(row, err && err.message ? err.message : 'Unable to update cart quantity.');
        });
        return;
      }
      if (dec) {
        clearLineFeedback(row);
        changeLine(lineKey, Math.max(0, q - 1)).catch(function (err) {
          setLineFeedback(row, err && err.message ? err.message : 'Unable to update cart quantity.');
        });
      }
    });

    function flushInputDebounce(input) {
      var row = getLineRow(input);
      var key = getLineKey(row);
      if (!key || !inputTimers[key]) return;
      clearTimeout(inputTimers[key]);
      delete inputTimers[key];
      commitInput(input);
    }

    function enforceInitialMax() {
      root.querySelectorAll('[data-cart-line]').forEach(function (row) {
        var maxAttr = row.getAttribute('data-line-max');
        var max = parseInt(maxAttr, 10);
        if (isNaN(max)) return;
        var input = row.querySelector('[data-cart-qty-input]');
        if (!input) return;
        var qty = parseInt(input.value, 10);
        if (isNaN(qty) || qty <= max) return;
        var lineKey = getLineKey(row);
        if (!lineKey) return;
        changeLine(lineKey, max).then(function () {
          var freshRow = document.querySelector('[data-cart-line][data-line-key="' + lineKey + '"]');
          setLineFeedback(freshRow || row, 'Quantity reduced to ' + max + ' (max available)');
        }).catch(function (err) {
          setLineFeedback(row, err && err.message ? err.message : 'Unable to update cart quantity.');
        });
      });
    }
    enforceInitialMax();

    root.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        var row = getLineRow(input);
        var key = getLineKey(row);
        if (!key) return;
        if (inputTimers[key]) clearTimeout(inputTimers[key]);
        inputTimers[key] = setTimeout(function () {
          delete inputTimers[key];
          commitInput(input);
        }, debounceMs);
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          flushInputDebounce(input);
        }
      });

      input.addEventListener('blur', function () {
        flushInputDebounce(input);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catalog-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cards = document.querySelectorAll('[data-catalog-card]');
    if (!cards.length) return;

    const pick = (arr, n) => {
      const a = arr.slice();
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a.slice(0, n);
    };

    cards.forEach((card) => {
      const pool = Array.from(card.querySelectorAll('[data-catalog-img]'));
      if (!pool.length) return;

      // Pile of 8-12 images, repeating source images when the collection has
      // fewer candidates than the target count.
      const count = 8 + Math.floor(Math.random() * 5);
      const shuffled = pick(pool, pool.length);
      const used = new Set();
      const display = [];
      for (let i = 0; i < count; i++) {
        const base = shuffled[i % shuffled.length];
        if (used.has(base)) {
          const clone = base.cloneNode(true);
          card.appendChild(clone);
          display.push(clone);
        } else {
          used.add(base);
          display.push(base);
        }
      }
      // Drop any source images that never got used.
      pool.forEach((img) => {
        if (!used.has(img)) img.remove();
      });

      const order = pick(display, display.length); // spread repeats around
      const place = (img, i, x, y) => {
        const rot = (Math.random() - 0.5) * 36;
        img.style.left = `${x}%`;
        img.style.top = `${y}%`;
        img.style.transform = `translate(-50%, -50%) rotate(${rot}deg)`;
        img.style.zIndex = String(i);
        img.classList.remove('hidden');
      };

      // Hardcode the four corners so the card is always covered there, with a
      // little jitter so it doesn't look pinned.
      const corners = [
        [10, 12],
        [90, 12],
        [10, 88],
        [90, 88],
      ];
      const cornerCount = Math.min(4, order.length);
      for (let i = 0; i < cornerCount; i++) {
        const [cx, cy] = corners[i];
        place(
          order[i],
          i,
          cx + (Math.random() - 0.5) * 7,
          cy + (Math.random() - 0.5) * 7,
        );
      }

      // Remaining images: Halton low-discrepancy sequence. It spreads points
      // evenly (no clumps, no gaps) but looks random, and it's O(n) with no
      // rejection loop. A random start index decorrelates it per card.
      const halton = (index, base) => {
        let r = 0;
        let f = 1;
        while (index > 0) {
          f /= base;
          r += f * (index % base);
          index = Math.floor(index / base);
        }
        return r;
      };
      const rest = order.slice(cornerCount);
      const start = 1 + Math.floor(Math.random() * 50);
      rest.forEach((img, j) => {
        // map into -8..108 so the pile bleeds slightly past every edge
        const x = -8 + halton(start + j, 2) * 116;
        const y = -8 + halton(start + j, 3) * 116;
        place(img, cornerCount + j, x, y);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function initHeaderCollectionLists() {
      document.querySelectorAll('[data-header-collection-list]').forEach(function (wrap) {
        var btn = wrap.querySelector('[data-header-collection-list-trigger]');
        if (!btn) return;
        function setExpanded(open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
        wrap.addEventListener('mouseenter', function () {
          setExpanded(true);
        });
        wrap.addEventListener('mouseleave', function () {
          setTimeout(function () {
            if (!wrap.contains(document.activeElement)) setExpanded(false);
          }, 0);
        });
        wrap.addEventListener('focusin', function () {
          setExpanded(true);
        });
        wrap.addEventListener('focusout', function () {
          setTimeout(function () {
            if (!wrap.contains(document.activeElement)) setExpanded(false);
          }, 0);
        });
      });
    }

    function initMobileNavColAccordions() {
      document
        .querySelectorAll('[data-mobile-nav-col-accordion]')
        .forEach(function (acc) {
          var btn = acc.querySelector('[data-mobile-nav-col-accordion-trigger]');
          if (!btn || btn.getAttribute('data-mobile-nav-col-accordion-bound') === '1')
            return;
          btn.setAttribute('data-mobile-nav-col-accordion-bound', '1');
          btn.addEventListener('click', function () {
            var isOpen = acc.classList.toggle('mobile-nav-col-list--open');
            btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          });
        });
    }

    var dialog = document.getElementById('mobile-nav');
    if (dialog) {
      var openers = document.querySelectorAll('[data-mobile-nav-open]');
      function setOpenersExpanded(open) {
        openers.forEach(function (b) {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }
      openers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          dialog.showModal();
          setOpenersExpanded(true);
        });
      });
      document.querySelectorAll('[data-mobile-nav-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dialog.close();
        });
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', function () {
        setOpenersExpanded(false);
      });
      dialog.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          dialog.close();
        });
      });
    }

    function initPriorityNav() {
      var navItems = document.querySelector('[data-priority-nav]');
      if (!navItems) return;
      var moreWrap = navItems.querySelector('[data-priority-nav-more]');
      var moreTrigger = navItems.querySelector('[data-priority-nav-more-trigger]');
      var moreMenu = navItems.querySelector('[data-priority-nav-more-menu]');
      var items = Array.from(
        navItems.querySelectorAll(':scope > [data-priority-nav-item]'),
      );
      if (!moreWrap || !moreTrigger || !moreMenu || !items.length) return;

      moreTrigger.addEventListener('click', function () {
        var hidden = moreMenu.style.display === 'none';
        moreMenu.style.display = hidden ? '' : 'none';
        moreTrigger.setAttribute('aria-expanded', hidden ? 'true' : 'false');
      });
      document.addEventListener(
        'click',
        function (e) {
          if (!moreWrap.contains(e.target)) {
            moreMenu.style.display = 'none';
            moreTrigger.setAttribute('aria-expanded', 'false');
          }
        },
        true,
      );

      function buildMenu() {
        moreMenu.innerHTML = '';
        items.forEach(function (item) {
          if (item.style.display !== 'none') return;
          var colList = item.querySelector('[data-header-collection-list]');
          if (colList) {
            var trigger = colList.querySelector('[data-header-collection-list-trigger]');
            var panel = colList.querySelector('[data-header-collection-list-panel]');
            if (trigger && panel) {
              var label = document.createElement('li');
              label.className =
                'px-3 pt-2 pb-0.5 text-xs text-mocha-700 font-bold uppercase tracking-wide select-none';
              label.textContent = trigger.textContent.trim();
              moreMenu.appendChild(label);
              panel.querySelectorAll('a').forEach(function (src) {
                var li = document.createElement('li');
                var a = src.cloneNode(true);
                a.className =
                  'block py-1.5 px-4 text-mocha-900 no-underline hover:bg-mocha-300 transition-colors rounded text-sm font-semibold';
                li.appendChild(a);
                moreMenu.appendChild(li);
              });
              return;
            }
          }
          var src = item.querySelector('a');
          if (!src) return;
          var li = document.createElement('li');
          var a = src.cloneNode(true);
          a.className =
            'block py-1.5 px-3 text-mocha-900 no-underline hover:bg-mocha-300 transition-colors rounded text-sm font-semibold';
          li.appendChild(a);
          moreMenu.appendChild(li);
        });
      }

      var busy = false;
      function update() {
        if (busy) return;
        busy = true;
        items.forEach(function (i) {
          i.style.display = '';
        });
        moreWrap.style.display = 'none';
        if (navItems.scrollWidth > navItems.offsetWidth) {
          moreWrap.style.display = '';
          for (var i = items.length - 1; i >= 0; i--) {
            if (navItems.scrollWidth <= navItems.offsetWidth) break;
            items[i].style.display = 'none';
          }
          buildMenu();
        }
        busy = false;
      }

      var outerNav = navItems.closest('nav');
      new ResizeObserver(update).observe(outerNav || navItems.parentElement);
      update();
    }

    initHeaderCollectionLists();
    initMobileNavColAccordions();
    initPriorityNav();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const layout = (grid) => {
      const styles = getComputedStyle(grid);
      const cols = styles.gridTemplateColumns.split(' ').filter(Boolean).length || 1;
      const gap = parseFloat(styles.columnGap) || 0;
      const row = parseFloat(styles.getPropertyValue('--masonry-row')) || 4;
      const colWidth = (grid.clientWidth - gap * (cols - 1)) / cols;

      grid.querySelectorAll(':scope > .masonry-gallery__item').forEach((item) => {
        const ratio = parseFloat(item.dataset.ratio) || 1;
        const span = Math.max(1, Math.round((colWidth * ratio + gap) / row));
        item.style.setProperty('--span', span);
      });
      grid.setAttribute('data-masonry-ready', '');
    };

    const init = (root) => {
      root.querySelectorAll('[data-masonry]').forEach((grid) => {
        if (grid.masonryObserver) return;
        let lastWidth = 0;
        grid.masonryObserver = new ResizeObserver(() => {
          // Spans only change grid height, so skip height-only resizes.
          if (grid.clientWidth === lastWidth) return;
          lastWidth = grid.clientWidth;
          layout(grid);
        });
        grid.masonryObserver.observe(grid);
      });
    };

    init(document);

    // Theme editor re-renders the section on setting/block changes.
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-masonry]').forEach((grid) => {
        grid.masonryObserver?.disconnect();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var track = document.querySelector('#product-showcase .scroll-track[data-randomizing]');
    if (track) {
      var pool = track.querySelector('.showcase-pool');
      var target = parseInt(track.getAttribute('data-target'), 10) || 10;
      var verified = document.documentElement.getAttribute('data-adult-verified') === 'true';
      var all = Array.prototype.slice.call(pool.children);
      var visible = all.filter(function (el) {
        return verified || el.getAttribute('data-adult') !== 'true';
      });

      // Fisher-Yates over the visible pool.
      for (var i = visible.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = visible[i];
        visible[i] = visible[j];
        visible[j] = tmp;
      }

      // Identity for adjacency dedupe — product URL is unique per product.
      var idOf = function (el) {
        var a = el.querySelector('a[href]');
        return a ? a.getAttribute('href') : el.outerHTML.length;
      };

      // Choose first N as the canonical set. If pool is smaller than N, use what we have.
      var chosen = visible.slice(0, Math.min(target, visible.length));
      if (chosen.length === 0) {
        track.removeAttribute('data-randomizing');
        track.style.visibility = '';
        return;
      }

      // Build set-A by cloning chosen[] with adjacency guard, padded to viewport width.
      // Set-B mirrors set-A exactly so the -50% animation wraps seamlessly; the only
      // visible seam in motion is lastOf(setA) → firstOf(setB) (= chosen[0]), and the
      // adjacency guard guarantees lastOf(setA) !== chosen[0].
      var minWidth = window.innerWidth + 400;
      var setA = document.createElement('div');
      setA.className = pool.className;
      track.replaceChild(setA, pool);

      var firstId = idOf(chosen[0]);
      var lastId = null;
      var cursor = 0;
      var safety = 200;
      var pushFromChosen = function () {
        var pick = chosen[cursor % chosen.length];
        var pid = idOf(pick);
        if (pid === lastId && chosen.length > 1) {
          cursor++;
          pick = chosen[cursor % chosen.length];
          pid = idOf(pick);
        }
        cursor++;
        lastId = pid;
        return pick.cloneNode(true);
      };

      // Seed set-A with chosen[] in order (using guard so chosen[0] adjacency is OK on wrap).
      for (var k = 0; k < chosen.length; k++) {
        setA.appendChild(chosen[k].cloneNode(true));
        lastId = idOf(chosen[k]);
      }
      cursor = 0;

      // Fill to width, ensuring seam end-of-A → start-of-B (= firstId) is not a repeat.
      while ((setA.getBoundingClientRect().width < minWidth || lastId === firstId) && safety-- > 0) {
        // If we're only padding to break the seam and width is already enough, but lastId
        // still collides with firstId, push one more guarded card.
        var prevLast = lastId;
        setA.appendChild(pushFromChosen());
        if (prevLast === lastId) break; // can't make progress (chosen.length === 1)
      }

      // Mirror set-A into set-B (aria-hidden clone).
      var setB = setA.cloneNode(true);
      setB.setAttribute('aria-hidden', 'true');
      setB.querySelectorAll('a').forEach(function (a) {
        a.setAttribute('tabindex', '-1');
        a.setAttribute('aria-hidden', 'true');
      });
      setB.querySelectorAll('article').forEach(function (art) {
        art.setAttribute('aria-hidden', 'true');
      });
      track.appendChild(setB);

      track.removeAttribute('data-randomizing');
      track.style.visibility = '';
    }

    document.querySelectorAll('#product-showcase article').forEach(function (card) {
      var shine = document.createElement('div');
      shine.className = 'card-shine';
      card.appendChild(shine);

      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var cx = rect.width / 2;
        var cy = rect.height / 2;
        var rotX = ((y - cy) / cy) * -5;
        var rotY = ((x - cx) / cx) * 5;

        card.style.transition = 'transform 80ms ease';
        card.style.transform =
          'perspective(700px) rotateX(' +
          rotX +
          'deg) rotateY(' +
          rotY +
          'deg) scale(1.05)';

        var sx = (x / rect.width) * 100;
        var sy = (y / rect.height) * 100;
        var midnight = document.documentElement.getAttribute('data-theme') === 'midnight';
        var spot = midnight
          ? 'var(--color-accent-100) 0%, transparent 65%'
          : 'color-mix(in srgb, var(--color-mocha-100) 42%, transparent) 0%, transparent 65%';
        shine.style.background =
          'radial-gradient(circle at ' + sx + '% ' + sy + '%, ' + spot + ')';
        shine.style.opacity = '1';
      });

      card.addEventListener('mouseleave', function () {
        card.style.transition = 'transform 250ms ease';
        card.style.transform = '';
        shine.style.opacity = '0';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recommended-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const grid = document.querySelector('#recommended-products .product-grid[data-randomizing]');
    if (grid) {
      const verified = document.documentElement.getAttribute('data-adult-verified') === 'true';
      const all = Array.from(grid.children);
      const visible = all.filter((el) => verified || el.getAttribute('data-adult') !== 'true');
      const hidden = all.filter((el) => !verified && el.getAttribute('data-adult') === 'true');
      for (let i = visible.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = visible[i];
        visible[i] = visible[j];
        visible[j] = tmp;
      }
      const frag = document.createDocumentFragment();
      visible.concat(hidden).forEach((el) => frag.appendChild(el));
      grid.appendChild(frag);
      grid.removeAttribute('data-randomizing');
      grid.style.visibility = '';
    }

    const cards = document.querySelectorAll('#recommended-products [data-fade-in]');
    if (!cards.length) return;
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.setAttribute('data-visible', '');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    cards.forEach((c) => io.observe(c));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-related-products]').forEach(async (root) => {
      if (root.dataset.fetched) return;
      root.dataset.fetched = '1';
      const endpoint = root.dataset.endpoint;
      if (!endpoint) return;
      try {
        const res = await fetch(endpoint);
        if (!res.ok) throw new Error(res.status);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-related-products]');
        if (fresh) {
          root.innerHTML = fresh.innerHTML;
          const cards = root.querySelectorAll('[data-fade-in]');
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const animateIn = (el, delay) => {
            el.setAttribute('data-visible', '');
            if (reduce) return;
            el.animate(
              [
                { opacity: 0, translate: '0 0.5rem' },
                { opacity: 1, translate: '0 0' },
              ],
              { duration: 350, delay, easing: 'ease-out', fill: 'both' }
            );
          };
          const io = new IntersectionObserver(
            (entries, obs) => {
              const visible = entries.filter((e) => e.isIntersecting);
              visible.forEach((e, i) => {
                animateIn(e.target, i * 60);
                obs.unobserve(e.target);
              });
            },
            { threshold: 0.15 }
          );
          cards.forEach((c) => io.observe(c));
        }
      } catch (e) {
        root.innerHTML = '';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
